import BackgroundIcon from "assets/icons/invoice/BackgroundIcon";
import FrameIcon from "assets/icons/invoice/FrameIcon";
import MarginIcon from "assets/icons/invoice/MarginIcon";
import SignIcon from "assets/icons/invoice/SignIcon";
import TextIcon from "assets/icons/invoice/TextIcon";
import BackgroundChild from "components/Print/patternChild/BackgroundChild";
import FrameChild from "components/Print/patternChild/FrameChild";
import MarginChild from "components/Print/patternChild/MarginChild";
import SignChild from "components/Print/patternChild/SignChild";
import TextChild from "components/Print/patternChild/TextChild";

const patternItems = [
  {
    title: "پس زمینه",
    Icon: BackgroundIcon,
    ChildComponent: BackgroundChild,
  },
  {
    title: "حاشیه کاغذ",
    Icon: FrameIcon,
    ChildComponent: FrameChild,
  },
  {
    title: "کادر",
    Icon: MarginIcon,
    ChildComponent: MarginChild,
  },
  {
    title: "نوشتار",
    Icon: TextIcon,
    ChildComponent: TextChild,
  },
  {
    title: "مهر و امضا",
    Icon: SignIcon,
    ChildComponent: SignChild,
  },
];

export default patternItems;
